import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface PageLoaderProps {
    text?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ text = 'טוען...' }) => {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.2 }}
                className="flex flex-col items-center gap-4"
            >
                {/* Loading spinner */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                >
                    <Loader2 className="w-8 h-8 text-red-600" />
                </motion.div>
                
                <span className="text-gray-600 font-medium">
                    {text}
                </span>
            </motion.div>
        </div>
    );
};

export default PageLoader;
